import { render, staticRenderFns } from "./UserQualificationEdit.vue?vue&type=template&id=839614ba"
import script from "./UserQualificationEdit.js?vue&type=script&lang=js&external"
export * from "./UserQualificationEdit.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports